import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/state/store'
import routes from './routes'

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  base: '/panel',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  //const routeMeta = routeTo.matched.some((route) => route.meta)
  const allowed = routeTo.meta.allowed;
  const title = routeTo.meta.title;

  const cfg = store.getters['cfg/get'];

  document.title = (cfg?.global?.information?.serverName ?? "Panel") + " » " + title;

  if (routeTo.meta && routeTo.meta.enabledPage) {
    const isEnabled = cfg?.global?.enabledPages?.dashboard[routeTo.meta.enabledPage] ?? true;

    if (!isEnabled) {
      return router.push({name: '404'});
    }
  }

  if (!allowed || allowed.length === 0)
    return next();
  
  if (allowed.includes('guest') && store.getters['auth/loggedIn']) {
    return next({ name: 'default' })
  }
  
  if (allowed.includes('auth') && !store.getters['auth/loggedIn']) {
      return redirectToLogin();
  }
  
  if (allowed.includes('registered') && !store.getters['auth/user'].isRegistered) {
    store.dispatch('notification/error', 'Najpierw się zarejestruj!');
    return next({ name: 'account.registration'});
  }

  return next();
  
  function redirectToLogin() {
    // Pass the original route to the login component
    next({name: 'loginToken', query: {redirectFrom: routeTo.fullPath}});
  }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          // Otherwise, continue resolving the route.
          resolve()
        }
      })
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return
  }

  // If we reach this point, continue resolving the route.
  next()
})

export default router
